import { render, staticRenderFns } from "./settedListInfo.vue?vue&type=template&id=046a7992&scoped=true&"
import script from "./settedListInfo.vue?vue&type=script&lang=js&"
export * from "./settedListInfo.vue?vue&type=script&lang=js&"
import style0 from "./settedListInfo.vue?vue&type=style&index=0&id=046a7992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a7992",
  null
  
)

export default component.exports